module.exports = __webpack_public_path__ + "img/igorroglić.c201d63d.jpg";